import { useQuery } from 'react-query';
import { queryCompany } from './useCompany.query';
import { UseCompanyOptions } from './useCompany.types';
import { Company } from '../../../types/models/company/company.types';

export const COMPANY_QUERY_KEY = 'COMPANY';

export const useCompany = (options?: UseCompanyOptions) => {
  return useQuery<Company, Error>(COMPANY_QUERY_KEY, () => queryCompany(), {
    ...options,
    retry: false,
    refetchOnWindowFocus: false,
  });
};
